 import { ISearchResult } from './search-results';

export enum ISearchDirection {
    NO_DIRECTION,
    ASCENDING,
    DESCENDING
}

export enum ISortField {
    NONE,
    TITLE,
    DATE
}

export interface ISort {
    display: string;
    sortField: ISortField;
    selected: boolean;
    direction: ISearchDirection;
    id: string;
}

export const initialSortModel: ISort[] = [
    {
        display: '',
        sortField: ISortField.NONE,
        selected: true,
        direction: ISearchDirection.NO_DIRECTION,
        id: 'relevance',
    },
    {
        display: '',
        sortField: ISortField.DATE,
        selected: false,
        direction: ISearchDirection.ASCENDING,
        id: 'newest',
    },
    {
        display: '',
        sortField: ISortField.DATE,
        selected: false,
        direction: ISearchDirection.DESCENDING,
        id: 'oldest',
    },
    {
        display: '',
        sortField: ISortField.TITLE,
        selected: false,
        direction: ISearchDirection.DESCENDING,
        id: 'title',
    },
    {
        display: '',
        sortField: ISortField.TITLE,
        selected: false,
        direction: ISearchDirection.ASCENDING,
        id: 'rTitle',
    },
];

export const memberSortModel: ISort[] = [
    {
        display: '',
        sortField: ISortField.NONE,
        selected: true,
        direction: ISearchDirection.NO_DIRECTION,
        id: 'relevance',
    },
    {
        display: '',
        sortField: ISortField.TITLE,
        selected: false,
        direction: ISearchDirection.DESCENDING,
        id: 'title',
    },
    {
        display: '',
        sortField: ISortField.TITLE,
        selected: false,
        direction: ISearchDirection.ASCENDING,
        id: 'rTitle',
    },
];
